<template>
    <a
        v-if="cardData"
        :class="[{ isDisabled: cardData.status === 4 }]"
        data-spm-data="h"
        :data-spm-content="dataSpmContent"
    >
        <div :class="['house-container']">
            <toast :infoText="infoText" :visible="visible"></toast>
            <div class="info-show">
                <div class="left">
                    <img
                        class="house-img"
                        :src="cardData.fields && cardData.fields.image"
                    />
                </div>
                <div class="left house-info">
                    <div>
                        <p class="title">{{ cardData.fields.title }}</p>
                        <p class="desc" v-if="cardData.fields.desc">
                            {{ cardData.fields.desc }}
                        </p>
                    </div>
                    <div
                        :class="[
                            'bottomContainer',
                            { is100Width: cardData.status === 4 },
                        ]"
                    >
                        <div>
                            <p class="place">
                                {{ cardData.fields.assemblyAddress }}
                            </p>
                            <p class="update">
                                {{ cardData.fields.deadlineString }}
                            </p>
                            <p class="suprise">{{ cardData.fields.remark }}</p>
                        </div>
                        <span
                            class="enlist"
                            :class="{ available: isAvailable }"
                            @click="showRegistration"
                            v-show="!isSignupStatus && cardData.status !== 4"
                            >{{ statusTxt }}</span
                        >
                    </div>
                </div>
            </div>
            <div class="registration-form" v-show="isSignupStatus">
                <ul>
                    <li class="nickname">
                        <span class="left">姓名</span>
                        <input
                            class="left"
                            placeholder="请输入姓名"
                            v-model="nameValue"
                        />
                    </li>
                    <li>
                        <span class="left">手机号</span>
                        <input
                            class="left"
                            placeholder="请输入手机号"
                            maxlength="11"
                            v-model="passportValue"
                        />
                    </li>
                    <li>
                        <span class="left">验证码</span>
                        <div class="left verification-content">
                            <input
                                class="verification left"
                                placeholder="请输入验证码"
                                v-model="codeValue"
                                maxlength="6"
                            />
                            <span
                                class="getCode left"
                                :class="{ 'code-active': isSendActive }"
                                @click.prevent="sendIdentCode"
                                ><em>{{ codeText }}</em></span
                            >
                        </div>
                    </li>
                </ul>
                <footer class="bottom-content">
                    <span
                        class="signup"
                        :class="{ active: isActive }"
                        @click="submit"
                        >立即报名</span
                    >
                    <span class="retract" @click="retractSignup"
                        >收起<i class="icon icon-retract"></i
                    ></span>
                </footer>
            </div>
        </div>
        <div class="house-bottom">
            <span class="isOverdue" v-if="cardData.status === 4">
                已失效
            </span>
            <span class="recommendText" v-if="cardData.accountName">
                <img :src="cardData.avatar" class="avatarImg" /><span
                    class="accountInfo"
                >
                    {{ cardData.accountName }} 推荐</span
                >
            </span>
        </div>
    </a>
</template>

<script>
import Toast from "../common/toast.vue";
import { getSignupStatus, getVeriCode } from "../request/index.js";
import Moment from "../../../_utils/moment";
export default {
    data() {
        return {
            //是否展示报名表
            isSignupStatus: false,
            //立即报名是否可点
            isAvailable: true,
            codeText: "获取验证码",
            statusTxt: "立即报名",
            //发送验证码按钮是否可点
            isSendActive: true,
            //立即报名是否可点
            isActive: true,
            //form表单各个值
            passportValue: "",
            nameValue: "",
            infoText: "",
            codeValue: "",
            //提示弹框是否显示
            visible: false,
            timer: null,
            isShowCard: false,
        };
    },
    mounted() {},
    computed: {
        isPhoneNumActive() {
            return this.checkPhoneNumber();
        },
        isNameActive() {
            return this.checkName();
        },
        isCodeActive() {
            return this.checkVeriCode();
        },
        cardUuid() {
            return this.uuid;
        },
        dataSpmContent() {
            return `||${this.cardUuid}||`;
        },
        cardData() {
            return this.articleData;
        },
    },
    watch: {
        visible() {
            this.isActive = !this.visible;
        },
    },
    methods: {
        showRegistration() {
            if (!this.isAvailable) return;
            this.isSignupStatus = true;
        },
        retractSignup() {
            this.isSignupStatus = false;
        },
        //发送验证码
        sendIdentCode() {
            if (!this.isSendActive) return;
            if (this.isPhoneNumActive) {
                this.getVeriCode();
            } else {
                this.setDialog("手机号格式有误，请重新输入");
            }
        },
        //检测手机号是否合法
        checkPhoneNumber() {
            const telReg = /^1([358][0-9]|4[579]|66|7[0135678]|9[89])[0-9]{8}$/;
            const _value = this.passportValue.trim();
            return telReg.test(_value);
        },
        //检测姓名是否合法
        checkName() {
            const nameReg = /^([\u4e00-\u9fa5]){2,5}$/;
            const _nameVal = this.nameValue.trim();
            return nameReg.test(_nameVal);
        },
        //检查验证码是否合法
        checkVeriCode() {
            const codeReg = /^\d{6}$/;
            const _codeVal = this.codeValue.trim();
            return codeReg.test(_codeVal);
        },
        // 激活验证码倒计时
        activeCodeInterval() {
            this.isSendActive = false;
            // 改变发送验证码的文案
            let leftTime = 60;
            this.codeText = `${leftTime}秒后重发`;
            if (!this.timer) {
                this.timer = setInterval(() => {
                    if (leftTime > 1) {
                        leftTime--;
                        this.codeText = `${leftTime}秒后重发`;
                    } else {
                        this.codeText = `获取验证码`;
                        clearInterval(this.timer);
                        this.timer = null;
                        if (this.isPhoneNumActive) {
                            this.isSendActive = true;
                        }
                    }
                }, 1000);
            }
        },
        //点击报名按钮验证
        checkStatus() {
            if (!this.isNameActive) {
                this.setDialog("名字输入有误，请重新输入");
                return;
            } else if (!this.isPhoneNumActive) {
                this.setDialog("手机号输入有误，请重新输入");
                return;
            } else if (!this.isCodeActive) {
                this.setDialog("验证码输入有误，请重新输入");
                return;
            } else {
                this.getSignupStatus();
            }
        },
        //接口返回验证
        checkBackendStatus(status, msg) {
            if (status == 2000000) {
                this.setDialog("报名成功！");
                this.retractSignup();
                this.statusTxt = "已报名";
                this.isAvailable = false;
            } else {
                this.setDialog(msg);
            }
        },

        submit() {
            if (!this.isActive) return;
            this.sendAction("8620");
            this.checkStatus();
        },
        //设置提示按钮信息
        setDialog(txt) {
            this.infoText = txt;
            this.visible = true;
            this.timer && clearTimeout(this.timer);
            setTimeout(() => {
                this.visible = false;
            }, 1500);
        },
        //获取卡片数据接口
        // getCardInfo() {
        //     Request.getCardInfo(this.cardUuid,
        //     (res)=>{
        //             let deadline = res.data && res.data[0].fields.applicationDeadline;
        //             let nowDate = new Date().getTime();
        //             let isOnline = nowDate > deadline ? false: true;
        //             if(!isOnline) {
        //                 this.isAvailable = false;
        //                 this.statusTxt = "已结束";
        //             }
        //             this.cardData = res.data && res.data[0];
        //     },
        //     ()=>{

        //     })
        // },
        //获取验证码接口
        getVeriCode() {
            let params = {
                id: this.cardUuid,
                phoneNum: this.passportValue,
            };
            getVeriCode(
                params,
                (res) => {
                    if (res.code === 2000000) {
                        this.activeCodeInterval();
                        this.sendAction("8621");
                    } else {
                        this.setDialog("验证码发送失败，请重试");
                    }
                },
                () => {
                    this.setDialog("验证码发送失败，请重试");
                }
            );
        },
        //报名接口
        getSignupStatus() {
            let params = {
                id: this.cardUuid,
                phoneNum: this.passportValue,
                articleId: window.cfgs.newsId,
                name: this.nameValue,
                captcha: this.codeValue,
            };
            getSignupStatus(
                params,
                (res) => {
                    this.checkBackendStatus(res.code, res.msg);
                    if (res.code == 2000000) {
                        this.sendAction("8622");
                    }
                },
                () => {}
            );
        },
        formatTime(timeStamp) {
            return new Moment(+timeStamp).format("MM月dd日");
        },
        sendAction(acode) {
            if (
                window.sohuSpm &&
                typeof window.sohuSpm.sendAction === "function"
            ) {
                window.sohuSpm.sendAction({
                    acode: acode,
                    clkParam: `accountId:${window.cfgs.media_id}; articleId:${window.cfgs.newsId};cardId:${this.cardUuid}`,
                });
            }
        },
    },
    components: {
        Toast,
    },
};
</script>

<style lang="less" scoped>
@import "../../../less/base/mixins.less";
#articleContent {
    .house-container {
        position: relative;
        background: rgba(255, 255, 255, 1);
        border: 1px solid rgba(229, 229, 229, 1);
        .info-show {
            height: 206px;
            display: flex;
        }
        .left {
            float: left;
            .house-img {
                width: 206px;
                height: 206px;
                margin-right: 25px;
                margin-bottom: 0 !important;
            }
        }
        .house-info {
            padding: 24px 22px 23px 0;
            width: 440px;
            .is100Width {
                width: 100% !important;
            }
            .bottomContainer {
                width: 276px;
                .place,
                .update,
                .suprise {
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    overflow: hidden;
                    font-size: 28px !important; /*px*/
                    line-height: 38px !important;
                    margin-bottom: 0px !important;
                    color: #a4a4a4;
                }
                .enlist {
                    bottom: 28px;
                    right: 20px;
                    position: absolute;
                    display: flex;
                    width: 160px;
                    height: 56px;
                    font-family: PingFang SC;
                    font-weight: bold;
                    color: #f94a25;
                    line-height: 36px; /*px*/
                    justify-content: center;
                    align-items: center;
                    border-radius: 1rem; /*px*/
                    background: rgba(245, 245, 245, 1);
                    font-size: 26px !important; /*px*/
                }
            }
        }
        .desc {
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
            margin-bottom: 7px;
            font-size: 28px !important; /*px*/
            line-height: 38px !important; /*px*/
            color: #a4a4a4;
        }
        .title {
            width: 400px;
            font-weight: 500;
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
            margin-bottom: 12px;
            height: 32px; /*px*/
            line-height: 32px; /*px*/
            font-size: 32px !important; /*px*/
            color: #3c3c3d;
        }

        .available {
            color: #ff0000;
        }
        .registration-form {
            box-sizing: border-box;
            padding: 0 0 29px 26px; /*px*/
            margin-top: 22px; /*px*/
            color: #333333;
            ul {
                margin: 0;
                list-style-type: none;
                li {
                    height: 66px;
                    margin-bottom: 20px;
                }
                input {
                    box-sizing: border-box;
                    height: 66px;
                    width: 524px;
                    padding: 20px;
                    border: 0;
                    border-radius: 4px;
                    line-height: 44px;
                    font-size: 26px !important; /*px*/
                    background: #f5f5f5;
                    color: #191919;
                    -moz-appearance: none;
                    -webkit-appearance: none;
                    appearance: none;
                }
                ::-webkit-input-placeholder {
                    /* WebKit browsers */
                    color: #999;
                }
                :-moz-placeholder {
                    /* Mozilla Firefox 4 to 18 */
                    color: #999;
                }
                ::-moz-placeholder {
                    /* Mozilla Firefox 19+ */
                    color: #999;
                }
                :-ms-input-placeholder {
                    /* Internet Explorer 10+ */
                    color: #999;
                }
                .verification-content {
                    box-sizing: border-box;
                    width: 524px;
                    height: 66px;
                    background: #f5f5f5;
                    .verification {
                        width: 355px;
                        height: 66px;
                    }
                    .getCode {
                        width: 166px;
                        em {
                            height: 26px;
                            padding-left: 18px;
                            font-size: 26px; /*px*/
                            border-left: 1px solid #dadada; /*no*/
                            color: #999999;
                        }
                        &:before {
                            display: inline-block;
                            content: "";
                            width: 1px; /*no*/
                            height: 26px;
                        }
                    }
                    .code-active {
                        em {
                            color: #ff0000;
                        }
                    }
                }
            }
            span {
                font-size: 26px !important; /*px*/
                display: inline-block;
                width: 122px;
                height: 66px;
                line-height: 66px;
            }
            .bottom-content {
                position: relative;
                padding-right: 10px;
                margin-top: 30px;
                text-align: center;
                .signup {
                    display: flex;
                    width: 160px;
                    height: 56px;
                    margin-left: 233px;
                    border-radius: 1rem;
                    justify-content: center;
                    align-items: center;
                    color: #ffffff;
                    background: #bababa;
                }
                .active {
                    background: #ff0000;
                }
                .retract {
                    position: absolute;
                    bottom: 0;
                    right: 0;
                    height: 56px;
                    line-height: 56px;
                    font-size: 26px !important; /*px*/
                    color: #999999;
                    .icon-retract {
                        height: 56px;
                        margin-left: 16px;
                        line-height: 56px;
                        font-size: 12px; /*px*/
                    }
                }
            }
        }
    }
    .house-bottom {
        margin-top: 16px;
        line-height: 24px;
        margin-bottom: 40px;
        padding: 0 10px;
        overflow: hidden;
        span {
            font-size: 24px !important; /*px*/
        }
        .isOverdue {
            float: left;
        }
        .recommendText {
            float: right;
            display: flex;
            justify-content: space-between;
            align-items: center;
            .avatarImg {
                width: 27px;
                height: 27px;
                display: inline-block;
                border-radius: 27px;
                margin: 0 8px 0 0;
            }
            .accountInfo {
                color: #b5b5b5;
                font-size: 24px; /*px*/
                font-family: PingFang SC;
                color: rgba(181, 181, 181, 1);
                line-height: 21px;
            }
        }
    }
}
.isDisabled {
    display: block;
    opacity: 0.5;
}
</style>
